/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_DocumentationInputs */

const en_svchip_documentation = /** @type {(inputs: Svchip_DocumentationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentation`)
};

const ar_svchip_documentation = /** @type {(inputs: Svchip_DocumentationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التوثيق`)
};

const bn_svchip_documentation = /** @type {(inputs: Svchip_DocumentationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ডকুমেন্টেশন`)
};

const de_svchip_documentation = /** @type {(inputs: Svchip_DocumentationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumentation`)
};

const es_svchip_documentation = /** @type {(inputs: Svchip_DocumentationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentación`)
};

const fr_svchip_documentation = /** @type {(inputs: Svchip_DocumentationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentation`)
};

const pt_svchip_documentation = /** @type {(inputs: Svchip_DocumentationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentação`)
};

const zh_svchip_documentation = /** @type {(inputs: Svchip_DocumentationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文档`)
};

const tr_svchip_documentation = /** @type {(inputs: Svchip_DocumentationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokümantasyon`)
};

const ru_svchip_documentation = /** @type {(inputs: Svchip_DocumentationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Документация`)
};

const pl_svchip_documentation = /** @type {(inputs: Svchip_DocumentationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumentacja`)
};

/**
* | output |
* | --- |
* | "Documentation" |
*
* @param {Svchip_DocumentationInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_documentation = /** @type {((inputs?: Svchip_DocumentationInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_DocumentationInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_documentation(inputs)
	if (locale === "bn") return bn_svchip_documentation(inputs)
	if (locale === "de") return de_svchip_documentation(inputs)
	if (locale === "es") return es_svchip_documentation(inputs)
	if (locale === "fr") return fr_svchip_documentation(inputs)
	if (locale === "pt") return pt_svchip_documentation(inputs)
	if (locale === "zh") return zh_svchip_documentation(inputs)
	if (locale === "tr") return tr_svchip_documentation(inputs)
	if (locale === "ru") return ru_svchip_documentation(inputs)
	if (locale === "pl") return pl_svchip_documentation(inputs)
	return en_svchip_documentation(inputs)
});